var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-badge"},[_c('span',{staticClass:"icon"},[_vm._t("default")],2),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }